import React, { lazy } from 'react';
import { Field } from 'formik';
import { getFilterLocaleValues } from 'globalutils/fmUtils';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));
const Select = lazy(() => import(`globalcomponents/UI/Select/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);

export const renderInputField = ({
  item,
  name,
  placeholder,
  value,
  isDisabled,
  field,
  handleEdit,
  id,
  updateField,
  i18n,
  type = 'text',
  onBlur = true
}) => (
  <Field
    name={name}
    handleOnChange={(event) =>
      handleEdit(event, {
        field,
        id: item.id,
        logId: id,
        callback: updateField
      })
    }
    as={Input}
    mode="dark"
    placeholder={i18n.t(placeholder)}
    value={value}
    type={type}
    disabled={isDisabled}
    {...(onBlur && {
      onBlur: (event) => {
        updateField({
          data: event,
          field,
          id: item.id,
          logId: id
        });
      }
    })}
  />
);

export const renderSelectField = ({
  item,
  name,
  field,
  value,
  isDisabled,
  handleEdit,
  id,
  updateField,
  i18n,
  drivers,
  onBlur = true
}) => (
  <Field
    name={name}
    onChange={(event) =>
      handleEdit(event, {
        field,
        id: item.id,
        logId: id,
        callback: updateField
      })
    }
    {...(onBlur && {
      onBlur: () => {
        updateField({
          data: item[field],
          field,
          id: item.id,
          logId: id
        });
      }
    })}
    as={Select}
    placeholder={i18n.t('common.pleaseSelect')}
    value={getFilterLocaleValues([value], i18n)}
    suggestions={getFilterLocaleValues(drivers, i18n)}
    className="Selectclass"
    disabled={isDisabled}
    type=""
  />
);

export const renderField = ({ content, width = '100%', mode = 'light' }) => (
  <FormStyle.default.FieldsWrapper width={width}>
    <FormStyle.default.TextWrapper mode={mode}>
      {content}
    </FormStyle.default.TextWrapper>
  </FormStyle.default.FieldsWrapper>
);

export const renderRow = ({ item, viewOnly, i18n, ...rest }) => {
  return {
    time_from: renderField({ content: item.time_from }),
    time_to: renderField({ content: item.time_to }),
    distance: renderField({
      content:
        typeof item.distance === 'number'
          ? item.distance.toFixed()
          : item.distance,
      width: '50px'
    }),
    location: renderField({
      content: renderInputField({
        item,
        name: 'location',
        placeholder: 'common.location',
        value: item.location,
        isDisabled: item.udReadOnly || viewOnly || item.readOnly,
        field: 'location',
        i18n,
        onBlur: false,
        ...rest
      })
    }),
    driverId: renderField({
      content: !viewOnly
        ? renderSelectField({
            item,
            name: 'driverId',
            field: 'driverId',
            value: item.driverId,
            isDisabled: item.udReadOnly || viewOnly,
            i18n,
            ...rest
          })
        : item?.driverId?.label || '-',
      mode: ''
    }),
    coDriverId: renderField({
      content: !viewOnly
        ? renderSelectField({
            item,
            name: 'coDriverId',
            field: 'coDriverId',
            value: item.coDriverId,
            isDisabled: item.udReadOnly || viewOnly,
            i18n,
            ...rest
          })
        : item?.coDriverId?.label || '-',
      mode: ''
    }),
    note: renderField({
      content: renderInputField({
        item,
        name: 'note',
        placeholder: 'common.note',
        value: item.note,
        isDisabled: item.udReadOnly || viewOnly || item.readOnly,
        field: 'note',
        i18n,
        ...rest
      })
    }),
    status: renderField({ content: i18n.t(item.status) })
  };
};
